import styled from "styled-components";

export const InstagramWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
